import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import createSchema from './tlsAccountForm.schema';

import {
  fetchInitialDataForTLSAccountModal,
} from './store/actions';
import {
  categoriesWithTagsForModalSelector,
  enabledFlagOptionsSelector,
  isFetchingInitialDataForModalSelector,
  sharedSelectors,
  tlsAccountsSelector,
} from './store/selectors';

import { TLSAccountPropTypes } from './propTypes';
import { PeriodPropTypes } from '../shared/propTypes';
import { OptionsPropType } from '../../shared/propTypes/common';

const ModalTitles = {
  ADD: 'Add TLS Account',
  EDIT: 'Edit TLS Account',
};

class AddTLSAccountModal extends PureComponent {
  static propTypes = {
    fetchInitialDataForTLSAccountModal: PropTypes.func.isRequired,
    isFetchingInitialDataForModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    enabledFlagOptions: OptionsPropType,
    categoriesWithTags: PropTypes.arrayOf(PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      defaultTag: PropTypes.string,
      tags: OptionsPropType,
    })).isRequired,
    period: PeriodPropTypes.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    entityToEdit: TLSAccountPropTypes,
    isVisible: PropTypes.bool,
    openForEdit: PropTypes.bool,
    tlsAccountsOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
  };

  componentDidMount() {
    const { fetchInitialDataForTLSAccountModal, period } = this.props;

    fetchInitialDataForTLSAccountModal({ periodName: period.name });
  }

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        ...formData,
        periodName: period.name,
      }, openForEdit, {
        params: { periodName: period.name, account: formData.account },
        callback: resetForm,
        keepOpenAfterSaving: addAnother,
      });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      enabledFlagOptions,
      hideModal,
      isVisible,
      isFetchingInitialDataForModal,
      isSavingInProgress,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-tls-account-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
        isLoading={isFetchingInitialDataForModal}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            enabledFlagOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, categoriesWithTags, tlsAccountsOptions, openForEdit } = this.props;

    const schema = createSchema({ categoriesWithTags });

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{
          tlsAccountsOptions,
          openForEdit,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  enabledFlagOptions: enabledFlagOptionsSelector(state),
  categoriesWithTags: categoriesWithTagsForModalSelector(state),
  isFetchingInitialDataForModal: isFetchingInitialDataForModalSelector(state),
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
  tlsAccountsOptions: tlsAccountsSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialDataForTLSAccountModal,
  }
)(AddTLSAccountModal);
